import { resetModals } from "../../store/slices/modalsSlice";
import { store } from "../../store/store";
import { Button } from "../ui/button";
import ModalWrapper from "./ModalWrapper";

const GeneralCTAModal = ({
  msg,
  yesMsg = "نعم",
  noMsg = "لا",
  yesHandler,
  noHandler = () => store.dispatch(resetModals()),
  closeOnClick = true,
}: {
  msg: string;
  yesMsg: string;
  noMsg: string;
  yesHandler: (props: any) => void;
  noHandler?: (props: any) => void;
  closeOnClick?: boolean;
}) => {
  return (
    <ModalWrapper closeOnClick={closeOnClick}>
      <div
        className="text-center bg-white rounded-lg px-5 py-4"
        style={{ minWidth: "25%" }}
      >
        <p className="text-xl">{msg}</p>
        <div className="flex justify-around items-center gap-2 py-4">
          <Button variant="success" onClick={yesHandler}>
            {yesMsg}
          </Button>
          <Button variant="destructive" onClick={noHandler}>
            {noMsg}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default GeneralCTAModal;
